import Vue from 'vue'

export default {
    props: {
        props: {
            type: Object,
            default: () => ({key: 'key', value: 'value'})
        }
    },
    methods: {
        hasLocalDic (key) {
            return Array.isArray(this.getLocalStorage(key).dir)
        },
        getLocalStorage (key) {
            const dir = JSON.parse(window.sessionStorage.getItem(`JDICTIONARY_${key}`))
            let cache = {}
            let last = dir && dir[dir.length - 1]
            if (last && last.cacheTimestamp) cache = dir.pop()
            return {
                dictionaryKey: cache.dictionaryKey,
                cacheTimestamp: cache.cacheTimestamp,
                dir,
                map: cache.map || {}
            }
        },
        setLocalStorage (array, key ,map) {
            if (!Array.isArray(array) || array.length < 1) return
            window.sessionStorage.setItem(`JDICTIONARY_${key}`, JSON.stringify([...array, { cacheTimestamp: Date.now(), dictionaryKey: key, map }]))
        },
        // 根据提供的字典数组和原始值value 获取字典文本值
        getDictionaryTextByArrayAndValue (array, value, props = { key: 'key', value: 'value' }) {
            let target = {}
            array.some(item => {
                if (item[props.key] == value) {
                    target = item
                    return true
                }
            })
            return target[props.value] || value
        },
        // 根据提供的字典key和原始值value 获取字典文本值
        getDictionaryTextByKeyAndValue (key, value, option) {
            if (option && option.length < 1) return
            if (!key) return value
            if (!Vue.store.state.JDictionary) {
                console.warn(`解析失败，未注册JDictionary Store`)
                return value
            }
            return Vue.store.state.JDictionary.Map[key][value] || value
        }
    }
}
